;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/costs\"},{\"path\":\"/history\"},{\"path\":\"/login\"},{\"path\":\"/notifications\"},{\"path\":\"/reports\"},{\"path\":\"/settings/activity\"},{\"path\":\"/settings/drivers\"},{\"path\":\"/settings/groups\"},{\"path\":\"/settings/poi\"},{\"path\":\"/settings/scheduled-reports\"},{\"path\":\"/settings/system\"},{\"path\":\"/settings/user\"},{\"path\":\"/settings/users\"},{\"path\":\"/settings/vehicles\"},{\"path\":\"/settings/zones\"},{\"path\":\"/tracking\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from "@sentry/nextjs";
import { ApiClientError } from "@/lib/api/http";
import { scrubEvent, sharedSentryOptions } from "@/lib/sentry/options";

Sentry.init({
  ...sharedSentryOptions,
  beforeSend(event, hint) {
    // 4xx from our own `/api/*` is expected (expired session, validation, missing permission) and
    // is already shown to the user as a toast — it is not a bug.
    const error = hint.originalException;
    if (error instanceof ApiClientError && error.status >= 400 && error.status < 500) {
      return null;
    }
    return scrubEvent(event);
  },
  ignoreErrors: [
    // Browser noise with no actionable stack.
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    "Non-Error promise rejection captured",
  ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
